export enum VehicleSymbol {
  Undefined = 0,
  LogStacker = 1,
  WheelLoaderFrontGrapple = 2,
  WheelLoaderHighGrapple = 3,
  TimberCrane = 4,
  CoilForklift = 5,
}
